'use strict';

import ApiEndpoint from './api_endpoint';

export default class ListChildren extends ApiEndpoint {
  execute(callback = undefined, session = undefined) {
    if (session === undefined) {
      return this.session.get('/people/list_children', undefined, callback);
    }
    return session.get('/people/list_children', undefined, callback);
  }
}
